import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 790BCBB6-8B08-4AEC-A322-99F584BB394B
 * name call-split
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/call-split.svg
 * tags
 * - Cellphone / Phone 
 * - Arrow 
 */
export const CallSplitIcon = createSvgIcon(<><path d="M14,4L16.29,6.29L13.41,9.17L14.83,10.59L17.71,7.71L20,10V4M10,4H4V10L6.29,7.71L11,12.41V20H13V11.59L7.71,6.29" /></>, 'CallSplitIcon');
export default CallSplitIcon